<template>
    <div class="row">
        <div class="small-12 columns" :class="{ error: showIsAMinorErrorText }">
            <label>
                Ist der Kontoinhaber minderjährig?
                <select v-model="formData.is_main_account_holder_minor">
                    <option
                        v-for="selectValue in defaultSelectValues"
                        :key="selectValue.value"
                        :value="selectValue.value"
                    >
                        {{selectValue.title}}
                    </option>
                </select>
            </label>
            <small class="error" v-if="showIsAMinorErrorText">
                {{ isAMinorErrorText }}
            </small>
        </div>
        <div v-if="showHasSubAccountHolderSelection" class="small-12 columns" :class="{ error: showHasSubHolderErrorText }">
            <label>
                Gibt es einen weiteren Kontoinhaber?
                <select v-model="formData.has_sub_account_holder">
                    <option
                        v-for="selectValue in defaultSelectValues"
                        :key="selectValue.value"
                        :value="selectValue.value"
                    >
                        {{selectValue.title}}
                    </option>
                </select>
            </label>
            <small class="error" v-if="showHasSubHolderErrorText">
                {{ hasSubHolderErrorText }}
            </small>
        </div>
        <template v-if="showSubAccountHolderSection">
            <div class="small-12 columns">
                <div class="sub-account-holder-section">
                    <h4>{{ subAccountHolderSectionTitle }}</h4>
                    <div :class="{ error: showSubAccountHolderLawformErrorText }">
                        <label>
                            Anrede
                            <select v-model="formData.sub_account_holder_lawform">
                                <option
                                    v-for="lawform in lawformSelectData"
                                    :key="lawform.value"
                                    :value="lawform.value"
                                >
                                    {{lawform.text}}
                                </option>
                            </select>
                        </label>
                        <small class="error" v-if="showSubAccountHolderLawformErrorText">
                            {{ subAccountHolderLawformErrorText }}
                        </small>
                    </div>
                    <div :class="{ error: showSubAccountHolderPrenameErrorText }">
                        <label>
                            Vorname
                            <input type="text" v-model="formData.sub_account_holder_prename"/>
                        </label>
                        <small class="error" v-if="showSubAccountHolderPrenameErrorText">
                            {{ subAccountHolderPrenameErrorText }}
                        </small>
                    </div>
                    <div :class="{ error: showSubAccountHolderSurnameErrorText }">
                        <label>
                            Nachname
                            <input type="text" v-model="formData.sub_account_holder_surname"/>
                        </label>
                        <small class="error" v-if="showSubAccountHolderSurnameErrorText">
                            {{ subAccountHolderSurnameErrorText }}
                        </small>
                    </div>
                    <div v-if="formData.is_main_account_holder_minor" :class=" {error: showIsAllowedRepresentorErrorText }">
                        <label class="checkbox-label">
                            <input type="checkbox" class="checkbox-margin" v-model="formData.is_allowed_representor"/>
                            <span>
                                Ich übe die elterliche Sorge allein aus oder bin vom anderen Elternteil zur alleinigen
                                Vertretung unseres Kindes in dieser Sache ermächtigt.
                            </span>
                        </label>
                        <small class="error" v-if="showIsAllowedRepresentorErrorText">
                            {{ isAllowedRepresentorErrorText }}
                        </small>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import TypeHelper from '../../helper/TypeHelper';
import Validation from '../../helper/Validation';
import AccountTypes from '../../constants/AccountTypes';
import Lawforms from '../../constants/Lawforms';

export default {
    name: 'AdditionalDataFormStep',
    props: {
        caseData: {
            type: Object,
            default: function()
            {
                return {
                    account_type:                                   null,
                    account_number:                                 null,
                    bank_name:                                      null,
                    bank_mail:                                      null,
                    main_account_holder_lawform:                    null,
                    main_account_holder_prename:                    null,
                    main_account_holder_surname:                    null,
                    main_account_holder_mail:                       null,
                    main_account_holder_company_name:               null,
                    is_main_account_holder_minor:                   null,
                    main_account_holder_payment_account_number:     null,
                    has_sub_account_holder:                         null,
                    sub_account_holder_lawform:                     null,
                    sub_account_holder_surname:                     null,
                    sub_account_holder_prename:                     null,
                    is_allowed_representor:                         null,
                    phishing_damage_amount:                         null,
                    phishing_date:                                  null
                }
            }
        }
    },
    data: () => ({
        formData: {
            is_main_account_holder_minor:                   null,
            has_sub_account_holder:                         null,
            sub_account_holder_lawform:                     null,
            sub_account_holder_surname:                     null,
            sub_account_holder_prename:                     null,
            is_allowed_representor:                         null
        },
        validation: {
            isFormDirty: false,
            isSubAccountHolderLawformDirty: false,
            isSubAccountHolderPrenameDirty: false,
            isSubAccountHolderSurnameDirty: false,
            isAMinorDirty: false,
            isHasSubHolderDirty: false,
            isIsAllowedRepresentorDirty: false
        },
        constants: {
            SELECT_VALUE_YES: {
                value: true,
                title: 'Ja'
            },
            SELECT_VALUE_FALSE: {
                value: false,
                title: 'Nein'
            }
        },
        lawformSelectData: [
            Lawforms.HERR,
            Lawforms.FRAU
        ],
    }),
    computed: {
        defaultSelectValues()
        {
            return [
                this.constants.SELECT_VALUE_YES,
                this.constants.SELECT_VALUE_FALSE
            ];
        },
        subAccountHolderSectionTitle()
        {
            if (this.formData.is_main_account_holder_minor)
                return 'Gesetzlicher Vertreter des Kontoinhabers'

            return 'Mitkontoinhaber'
        },
        showSubAccountHolderSection()
        {
            return this.caseData.has_sub_account_holder === true || this.caseData.is_main_account_holder_minor === true;
        },
        showHasSubAccountHolderSelection()
        {
            return this.formData.is_main_account_holder_minor === false;
        },
        showSubAccountHolderLawformErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isSubAccountHolderLawformDirty)
                && TypeHelper.isNotNullOrUndefined(this.subAccountHolderLawformErrorText);
        },
        showSubAccountHolderPrenameErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isSubAccountHolderPrenameDirty)
                && TypeHelper.isNotNullOrUndefined(this.subAccountHolderPrenameErrorText);
        },
        showSubAccountHolderSurnameErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isSubAccountHolderSurnameDirty)
                && TypeHelper.isNotNullOrUndefined(this.subAccountHolderSurnameErrorText);
        },
        showIsAMinorErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isAMinorDirty)
                && TypeHelper.isNotNullOrUndefined(this.isAMinorErrorText);
        },
        showHasSubHolderErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isHasSubHolderDirty)
                && TypeHelper.isNotNullOrUndefined(this.hasSubHolderErrorText);
        },
        showIsAllowedRepresentorErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isIsAllowedRepresentorDirty)
                && TypeHelper.isNotNullOrUndefined(this.isAllowedRepresentorErrorText);
        },
        subAccountHolderLawformErrorText()
        {
            let validators = [];

            if (this.formData.is_main_account_holder_minor === true || this.formData.has_sub_account_holder === true)
                validators.push(Validation.requiresSelect);

            return Validation.runValidation(this.formData.sub_account_holder_lawform, validators);
        },
        subAccountHolderPrenameErrorText()
        {
            let validators = [];

            if (this.formData.is_main_account_holder_minor === true || this.formData.has_sub_account_holder === true)
                validators.push(Validation.isNotNull);

            return Validation.runValidation(this.formData.sub_account_holder_prename, validators);
        },
        subAccountHolderSurnameErrorText()
        {
            let validators = [];

            if (this.formData.is_main_account_holder_minor === true || this.formData.has_sub_account_holder === true)
                validators.push(Validation.isNotNull);

            return Validation.runValidation(this.formData.sub_account_holder_surname, validators);
        },
        isAMinorErrorText()
        {
            let validators = [];

            if (this.caseData.account_type === AccountTypes.ACCOUNT_TYPE_PRIVATE.value)
                validators.push(Validation.requiresSelect);

            return Validation.runValidation(this.formData.is_main_account_holder_minor, validators);
        },
        hasSubHolderErrorText()
        {
            let validators = [];

            if (this.formData.is_main_account_holder_minor === false)
                validators.push(Validation.requiresSelect);

            return Validation.runValidation(this.formData.has_sub_account_holder, validators);
        },
        isAllowedRepresentorErrorText()
        {
            let validators = [];

            if (this.formData.is_main_account_holder_minor === true)
                validators.push(Validation.requiresCheck);

            return Validation.runValidation(this.formData.is_allowed_representor, validators);
        }
    },
    methods: {
        validate()
        {
            this.validation.isFormDirty = true;

            this.emitValidity();
        },
        emitValidity()
        {
            this.$emit('updateValidity', this.isFormValid());
        },
        isFormValid()
        {
            let isValid = true;

            isValid = isValid && (this.subAccountHolderLawformErrorText === null);
            isValid = isValid && (this.subAccountHolderPrenameErrorText === null);
            isValid = isValid && (this.subAccountHolderSurnameErrorText === null);
            isValid = isValid && (this.isAMinorErrorText === null);
            isValid = isValid && (this.hasSubHolderErrorText === null);
            isValid = isValid && (this.isAllowedRepresentorErrorText === null);

            return isValid;
        },
        emitChangedData()
        {
            this.$emit('changeCaseData', this.formData);
        }
    },
    watch: {
        'caseData.account_type': function(newValue)
        {
            if (newValue === AccountTypes.ACCOUNT_TYPE_BUSINESS.value)
            {
                this.formData.sub_account_holder_lawform = null;
                this.formData.sub_account_holder_prename = null;
                this.formData.sub_account_holder_surname = null;
                this.formData.is_main_account_holder_minor = null;
                this.formData.has_sub_account_holder = null;
                this.formData.is_allowed_representor = null;
            }

            this.emitValidity();
        },
        'formData.sub_account_holder_lawform': function()
        {
            this.validation.isSubAccountHolderLawformDirty = true;
        },
        'formData.sub_account_holder_prename': function()
        {
            this.validation.isSubAccountHolderPrenameDirty = true;
        },
        'formData.sub_account_holder_surname': function()
        {
            this.validation.isSubAccountHolderSurnameDirty = true;
        },
        'formData.is_main_account_holder_minor': function (newValue)
        {
            this.formData.sub_account_holder_lawform = null;
            this.formData.sub_account_holder_prename = null;
            this.formData.sub_account_holder_surname = null;
            this.validation.isAMinorDirty = true;

            if (newValue === true)
                this.formData.has_sub_account_holder = null;
            else
                this.formData.is_allowed_representor = null;
        },
        'formData.has_sub_account_holder': function ()
        {
            this.formData.sub_account_holder_lawform = null;
            this.formData.sub_account_holder_prename = null;
            this.formData.sub_account_holder_surname = null;
            this.validation.isHasSubHolderDirty = true;
        },
        'formData.is_allowed_representor': function()
        {
            this.validation.isIsAllowedRepresentorDirty = true;
        },
        formData: {
            handler: function()
            {
                this.emitChangedData();
                this.emitValidity();
            },
            deep: true
        },
    }
};
</script>

<style scoped>
    .error label {
        color: #4d4d4d;
    }

    .sub-account-holder-section {
        border: 1px solid #d8d8d8;
        background: #ededed;
        padding: 10px;
        margin-bottom: 10px;
    }

    select {
        margin: 0 0 1rem;
    }

    .error select {
        margin-bottom: 0;
    }

    .checkbox-margin {
        margin-bottom: 0;
    }

    .checkbox-label {
        display: flex;
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .error .checkbox-label {
        margin-bottom: 0;
    }

    .checkbox-label input[type=checkbox] {
        flex: none;
    }

    .checkbox-label span {
        margin-left: 10px;
    }

    .error .checkbox-label span {
        margin-top: -4px;
    }
</style>